import DocumentDetailController from './document.detail.controller';

export default {
    template: require('./document.detail.html'),
    controller: DocumentDetailController
};
